import React, { useContext, useEffect } from "react";
import noteContext from "../Context/Notes/NotesContext";
import Notes from "./Notes";
import AddNote from "./AddNote";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();
  const context = useContext(noteContext);
  const { notes } = context;
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
  }, []);

  return (
    <>
      <div className="">
        <div className="homeDisplay container-sm">
          <div className="conatiner container-sm">
            <AddNote className="" heading="Add Note" setAddBtn={true} />
          </div>
        </div>
        <div>
          <div className={`container  ${notes.length === 0 ? "d-none" : ""}`}>
            <h1 className="default_font">Your Notes</h1>
          </div>
          {localStorage.getItem("token") && <Notes />}
        </div>
      </div>
    </>
  );
}

export default Home;
